module.exports = __webpack_public_path__ + "static/media/silver-weekly.2a18f3d1.svg";